// src/arrays/to-array/to-array.ts
var toArray = (value) => [value].flat();

export {
  toArray
};
